import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { confirmSignIn } from "aws-amplify/auth";

interface IVerifyOtp {
  otp: string;
}

export const verifyOtp = createAsyncThunk(
  "verifyOTP",
  async ({ otp }: IVerifyOtp, thunkAPI) => {
    const { dispatch } = thunkAPI;

    try {
      const { nextStep: confirmSignInNextStep } = await confirmSignIn({
        challengeResponse: otp,
      });
      if (confirmSignInNextStep.signInStep === "DONE") {
        console.log("Sign in successful!");
        dispatch(setOTPInValid({ value: false }));
      } else {
        dispatch(setOTPInValid({ value: true }));
      }
    } catch (error) {
      console.error("Error confirming sign in with OTP:", error);
      return thunkAPI.rejectWithValue("Error Occurred");
    }
  }
);

const verifyOtpSlice = createSlice({
  name: "verifyOTP",
  initialState: {
    loading: false,
    error: false,
    success: false,
    OTPInValid: false,
  },
  reducers: {
    setOTPInValid: (state, action) => {
      state.OTPInValid = action.payload.value;
    },
    setSuccess: (state, action) => {
      state.success = action.payload.value;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(verifyOtp.pending, (state) => {
      state.loading = true;
      state.error = false;
      state.success = false;
    });
    builder.addCase(verifyOtp.fulfilled, (state) => {
      state.loading = false;
      state.success = true;
    });
    builder.addCase(verifyOtp.rejected, (state) => {
      state.loading = false;
      state.error = true;
      state.OTPInValid = true;
    });
  },
});

export const { setOTPInValid, setSuccess } = verifyOtpSlice.actions;
export default verifyOtpSlice.reducer;
